// import api from 'api';
import moment from "moment";
import UtilsUrl from "../../utils/UtilsUrl";
import api from "./../api";

const getFilteredEmployees = async (idUser, filter) => {
  try {
    const response = await api.get(
      UtilsUrl.rhURL() + `/employees/filtred/${idUser}?filter=${filter}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching filtered employees:", error);
    throw error;
  }
};

const saveOrderMission = async (idPersonnel, idUser, formData) => {
  const { dateDeb, dateFin, ...otherFormData } = formData;
  const formattedFormData = {
    ...otherFormData,
    dateDeb: moment(formData.dateDeb).format("YYYY-MM-DD"),
    dateFin: moment(formData.dateFin).format("YYYY-MM-DD"),
  };
  try {
    const res = await api.post(
      UtilsUrl.rhURL() +
        `/ordredemission/saveOrderMission/${idPersonnel}/${idUser}`,
      formattedFormData
    );
    return res.data;
  } catch (error) {
    throw new Error(error.response.data);
  }
};
const isEmployeeOnMission = async (employeeId) => {
  return await api.get(
    UtilsUrl.rhURL() + `/ordredemission/is-on-mission/${employeeId}`
  );
};
const countemployeesInMission = async (idUser) => {
  return await api.get(
    UtilsUrl.rhURL() + "/ordredemission/countemployeesInMission/" + idUser
  );
};
const getChargesByOrdreDeMissionsForCurrentMonth = async (idUser) => {
  try {
    const resp = await api.get(
      UtilsUrl.rhURL() + `/ordredemission/charges/` + idUser
    );
    console.log("charges", resp);
    return resp.data;
  } catch (error) {
    console.error("Error in API request:", error);
    throw error; // Re-throw the error to handle it in the calling function if needed
  }
};
const getAllMissionEnCours = async (idUser) => {
  try {
    const response = await api.get(
      UtilsUrl.rhURL() + "/ordredemission/missionsEnCours/" + idUser
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};
const getAllMissionsEnHistorique = async (idUser) => {
  try {
    const response = await api.get(
      UtilsUrl.rhURL() + "/ordredemission/missionsEnHistorique/" + idUser
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};
const getDetailMissionById = async (idMission) => {
  return await api.get(
    UtilsUrl.rhURL() + `/ordredemission/getMissionDetail/${idMission}`
  );
};

const updateOrdreDeMission = async (id, ordreDeMission) => {
  return await api.put(
    UtilsUrl.rhURL() + `/ordredemission/update/${id}`,
    ordreDeMission
  );
};
export {
  getFilteredEmployees,
  saveOrderMission,
  isEmployeeOnMission,
  countemployeesInMission,
  getChargesByOrdreDeMissionsForCurrentMonth,
  getAllMissionEnCours,
  getAllMissionsEnHistorique,
  getDetailMissionById,
  updateOrdreDeMission,
};
